import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { RootState } from '../../models/RootState';
import {
  fetchBalance,
  logout,
  fetchBettingCurrency,
  setEventType,
} from '../../store';
import Modal from '../../components/Modal/Modal';

import {
  EXCHANGE_EVENT_TYPES,
  EXCH_SPORTS_MAP,
} from '../../constants/ExchangeEventTypes';
import { SelectedObj } from '../../models/ExchangeSportsState';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';
import './SubHeader.scss';
import { Backdrop, Button, Tabs } from '@material-ui/core';
import LoginForm from '../../components/LoginForm/LoginForm';

type StoreProps = {
  allowedConfig: number;
  loggedIn: boolean;
  logout: Function;
  langData : any;
};

const SubHeader: React.FC<StoreProps> = (props) => {
  const { allowedConfig,langData } = props;
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const excheventsList = EXCHANGE_EVENT_TYPES;

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div className="app-sub-header">
        <Tabs
          value={1}
          variant="scrollable"
          scrollButtons="off"
          className="actions-list"
        >
          {(allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 ? (
            <NavLink
              to="/exchange_sports/inplay"
              className="nav-link"
              activeClassName="active-link"
            >
              {/* <IonImg className="inplay-img" src={InplayImg} /> */}
              <Button className="nav-link-btn">{langData?.['inplay']}</Button>
            </NavLink>
          ) : null}
          {(allowedConfig & CONFIG_PERMISSIONS.indian_casino) !== 0 ? (
            <NavLink
              to="/indian_casino"
              className="nav-link"
              activeClassName="active-link"
            >
              <Button className="nav-link-btn">{langData?.['indian_casino']}</Button>
            </NavLink>
          ) : null}

          {/* {(allowedConfig & CONFIG_PERMISSIONS.cricket) !== 0 ? (
            <NavLink
              className="nav-link"
              activeClassName="active-link"
              to={`/exchange_sports/cricket/icc-world-cup/winner/${btoa(
                WORLD_CUP.routeHash
              )}`}
            >
              <Button className="nav-link-btn color-change">
                ICC T20 WINNER
              </Button>
            </NavLink>
          ) : null} */}

          {excheventsList.map((et, idx) =>
            (EXCH_SPORTS_MAP[et.slug] & allowedConfig) !== 0 ? (
              <NavLink
                key={et.slug + idx}
                activeClassName="active-link"
                exact={true}
                to={'/exchange_sports/' + et.slug}
                className="nav-link"
                onClick={() => setEventType(et)}
              >
                <Button className="nav-link-btn">{langData?.[et.langKey]}</Button>
              </NavLink>
            ) : null
          )}

          {/* {(allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 ? (
            <NavLink
              to="/virtual_sports"
              className="nav-link"
              activeClassName="active-link"
            >
              <Button className="nav-link-btn">Virtual Cricket</Button>
            </NavLink>
          ) : null} */}

          {(allowedConfig & CONFIG_PERMISSIONS.live_casino) !== 0 ? (
            <NavLink
              to="/casino"
              className="nav-link"
              activeClassName="active-link"
            >
              <Button className="nav-link-btn">{langData?.['live_casino']}</Button>
            </NavLink>
          ) : null}

          {(allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 ? (
            <NavLink
              to="/tv_games"
              className="nav-link"
              activeClassName="active-link"
            >
              <Button className="nav-link-btn">{langData?.['tv_games']}</Button>
            </NavLink>
          ) : null}

          {/* {(allowedConfig & CONFIG_PERMISSIONS.binary) !== 0 ? (
            <NavLink
              activeClassName="active indian-casino-active"
              to="/exchange_sports/binary"
              className="nav-link"
            >
              <Button className="nav-link-btn color-change">Binary</Button>
            </NavLink>
          ) : null} */}
        </Tabs>
      </div>
      <Backdrop className="backdrop-ctn" open={modalOpen}>
        <Modal
          open={modalOpen}
          closeHandler={modalCloseHandler}
          noTitle={true}
          size="xs"
        >
          <LoginForm modalCloseHandler={modalCloseHandler}></LoginForm>
        </Modal>
      </Backdrop>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    allowedConfig: state.common.allowedConfig,
    loggedIn: state.auth.loggedIn,
    langData:state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBalance: () => dispatch(fetchBalance()),
    logout: () => dispatch(logout()),
    fetchBettingCurrency: () => dispatch(fetchBettingCurrency()),
    setEventType: (et: SelectedObj) => dispatch(setEventType(et)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubHeader);
